import { Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { UserSubscription, UserSubscriptionType } from "../../../user/user-subscription";
import { User } from "../../../user/user";
import { CommonModule } from '@angular/common';
import {DbTextPipe} from "../../../shared/pipes/db-text.pipe";
@Component({
    selector: 'db-pricing-period-switcher',
    templateUrl: './pricing-period-switcher.component.html',
    styleUrls: ['./pricing-period-switcher.component.scss'],
  imports: [CommonModule, DbTextPipe],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PricingPeriodSwitcherComponent),
            multi: true,
        }
    ]
})
export class PricingPeriodSwitcherComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() currentSubscription: UserSubscription;
  @Input() dontChangeSwitchValue?: boolean;
  @Input() size: ''|'sm';
  @Input() user: User;
  @Input() limitedTimeOffer: boolean = false;
  @Input() disabled: boolean = false;
  @Input() small?: boolean = false;
  @Input() hideBadge?: boolean;
  @Input() uppercaseTitle?: boolean = true;
  @Input() isMobile?: boolean = false;
  @Input() isAgency?: boolean = false;
  @Input() fromPopup?: boolean = false;
  @Input() isApiReseller?: boolean = false;

  @Input() value: number;
  @Output() valueChange = new EventEmitter<number>();

  public toggled: boolean = true;
  public UserSubscriptionType = UserSubscriptionType;

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.initializeToggled();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']) {
      this.setDisabledState(changes['disabled'].currentValue);
    }
    if (changes['value']) {
      this.initializeToggled();
    }
  }

  private initializeToggled(): void {
    if (this.small || this.dontChangeSwitchValue) {
      this.toggled = this.value === 1;
    } else if (this.currentSubscription?.type === 'starter') {
      this.toggled = false;
    } else {
      this.toggled = this.currentSubscription.plan.periodNumber === 1 || this.currentSubscription.plan.periodNumber === 6;
    }
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
      this.initializeToggled();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (isDisabled) {
      this.elementRef.nativeElement.classList.add('disabled');
    } else {
      this.elementRef.nativeElement.classList.remove('disabled');
    }
  }

  public onSwitch(value: number): void {
    if (!this.disabled) {
      this.value = value;
      this.toggled = value === 1;
      this.onChange(value);
      this.onTouched();
      this.valueChange.emit(value);
    }
  }

  public getTitle(period: number): string {
    return period === 1 ? 'Monthly' : 'Annual';
  }

  public getBadgeText(period: number): string {
    if (period === 12) {
      return this.limitedTimeOffer ? 'Limited time offer' : 'Save up to 50%';
    }
    return '';
  }
}
